import { observer } from 'mobx-react-lite';
import { Input, Switch, Drawer, Tooltip } from 'antd';
import ImgPreview from './imgPreview';
import SingleSelect from '@/components/aigc-form/select/single-select';
import SecondaryConfirm from '@/components/modal/secondary-confirm';
import { HelpOther } from '@/common/helper';
import { SVGPureIcon } from '@/ui';
import { aigcFormStore } from '@/components/aigc-form/store';
import WorkPublish from '@/components/modal/work-publish';
import AigcBGMOptions from '@/components/aigc-form/select/aigc-bgm-options';
import { request } from '@/common';
import AigcFormItem from '@/components/aigc-form/aigc-form-item';
import WorkList from './workList';
import { useState, useEffect, useMemo } from 'react';
import '../index.scss';
import { aigcBGMStore } from '@/components/aigc-form/store/bgm-list';

const Publish = observer<{
  data: any;
  type: string;
}>(({ data, type }) => {
  const dataJSON = JSON.parse(data?.data || '{}');
  const [modelValue, updateModelValue] = useState('');
  const [sameWork, setSameWork] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showBgm, setShowBgm] = useState(false);
  const [bgmId, setBgmId] = useState('auto');
  const [imgList, setImgList] = useState([]);
  // 添加闪烁状态
  const [isFlashing, setIsFlashing] = useState(false);
  const errorMsg = '发布失败';
  const successMsg = '作品已提交发布，审核中...';

  // 闪烁输入框的函数
  const flashTextArea = () => {
    setIsFlashing(true);

    // 第一次取消选中
    setTimeout(() => {
      setIsFlashing(false);

      // 第二次选中
      setTimeout(() => {
        setIsFlashing(true);

        // 第二次取消选中
        setTimeout(() => {
          setIsFlashing(false);
        }, 200);
      }, 500);
    }, 500);
  };

  const publishQuery = () => {
    if (type === 'video') {
      request
        .post(
          'media/publish?appsource=so',
          {
            mid: data?.biz_id,
            mtype: data?.biz_type === 'text_video' ? 'text_video' : 'image_video',
            title: modelValue,
            follow: sameWork ? 1 : 0,
            syncComment: 0,
          }, // @ts-ignore
          { dataIsJson: true }
        )
        .then(() => {
          setIsLoading(false);
          HelpOther.toast(successMsg, 'success');
          WorkPublish.close();
        })
        .catch(() => {
          setIsLoading(false);
          HelpOther.toast(errorMsg, 'error');
        });
    } else {
      const images = imgList.map(item => {
        return {
          ...item,
          mtype: 'image_image',
        };
      });
      request
        .post(
          'media/publish_images?appsource=so',
          {
            title: modelValue,
            follow: sameWork ? 1 : 0,
            bgm_id: bgmId,
            bgm: bgmItem?.voice_url,
            images,
          }, // @ts-ignore
          { dataIsJson: true }
        )
        .then(() => {
          WorkPublish.close();
          setIsLoading(false);
          HelpOther.toast(successMsg, 'success');
        })
        .catch(() => {
          setIsLoading(false);
          HelpOther.toast(errorMsg, 'error');
        });
    }
  };

  const submit = async () => {
    if (modelValue?.length <= 0) {
      HelpOther.toast('作品描述不能为空', 'warning');
      // 触发闪烁效果
      flashTextArea();
      return;
    }
    const res = await request.post(
      'media/repeat_publish?appsource=so',
      {
        mid: data?.biz_id,
        mtype: data?.biz_type,
      }, // @ts-ignore
      { dataIsJson: true }
    );
    const isPublished = res?.data?.is_published;
    if (isPublished) {
      SecondaryConfirm.show({
        title: '发布确认',
        text: '您之前已经发布过此作品，确认再次发布吗？',
        cancelBtn: '取消',
        confirmBtn: '确认发布',
        handleAction: () => {
          SecondaryConfirm.close();
          setIsLoading(true);
          publishQuery();
        },
      });
      return;
    }
    setIsLoading(true);
    publishQuery();
  };

  useEffect(() => {
    if (dataJSON?.out_images_w) {
      let list = [];
      JSON.parse(dataJSON?.out_images_w || '[]').forEach((item, index) => {
        if (item?.url) {
          list.push({
            mid: data?.biz_id,
            mtype: data?.biz_type,
            url: item?.url_download || item?.url,
            num: index + 1,
            id: item?.b_id,
          });
        }
      });
      setImgList(list);
    }
  }, [dataJSON?.out_images_w]);

  const bgmItem = useMemo(() => {
    return (
      aigcFormStore?.listData?.musicMap?.bgms.find(
        item => item?.id === bgmId
      ) || aigcFormStore?.listData?.musicMap?.bgms[0]
    );
  }, [aigcFormStore?.listData?.musicMap?.bgms, bgmId]);

  useEffect(() => {
    if (!aigcFormStore?.listData?.musicMap?.bgms?.length) {
      aigcFormStore?.fetchBgmList();
    }
  }, []);

  const onSelect = (img, isChecked, index, id) => {
    const newImgList = [...imgList];
    if (isChecked) {
      if (imgList.length <= 1) {
        return;
      }
      const list = newImgList.filter(item => item?.id !== img?.b_id);
      setImgList(list);
    } else {
      newImgList.push({
        mid: id,
        mtype: 'image_image',
        url: img?.url_download || img?.url,
        num: index,
        id: img?.b_id,
      });
      setImgList(newImgList);
    }
  };
  const onShowDopdown = () => {
    setShowBgm(!showBgm);
  };
  const onSelectBGM = item => {
    setBgmId(item?.id);
  };
  const huhandleDelete = (index: number) => {
    const newImgList = [...imgList];
    newImgList.splice(index, 1);
    setImgList(newImgList);
  };
  return (
    <div className="work-publish-confirm flex !w-1040px h-[calc(100vh-120px)] max-h-[740px]">
      <div className="flex flex-col gap-18px flex-[3] bg-[#F7F8FC] py-20px px-30px">
        <div className="text-16px text-[#1D2129] font-bold">发布作品</div>
        <div
          className={`${type === 'video' ? 'rounded-20px' : ''} overflow-hidden h-full bg-[#292E38]`}
        >
          {type === 'video' ? (
            <video
              className={['size-full object-contain'].join(' ')}
              src={dataJSON?.url_download}
              controls
              controlsList="nodownload noremoteplayback"
              disablePictureInPicture={true}
            />
          ) : (
            <ImgPreview
              list={imgList}
              huhandleAdd={() => setShowList(!showList)}
              huhandleDelete={huhandleDelete}
            />
          )}
        </div>
      </div>
      <div className="publish-form flex-[2] flex flex-col bg-[#fff] py-20px px-10px pt-36px pr-14px relative">
        <Drawer
          placement="right"
          closable={false}
          mask={false}
          open={showBgm}
          getContainer={false}
        >
          <div className="flex flex-col h-full gap-20px">
            <div className="flex items-center justify-between text-14px text-[#1d21294f]">
              <div
                className="flex cursor-pointer gap-4px items-center justify-center text-[#1d212982] hover:text-[#1d2129]"
                onClick={() => {
                  aigcBGMStore.pauseAudio();
                  setShowBgm(false)
                }}
              >
                <SVGPureIcon name="return" size={16} />
                返回
              </div>
              <div className='mr-20px'>仅在纳米APP端生效</div>
            </div>
            <AigcBGMOptions
              modelValue={bgmId}
              updateModelValue={onSelectBGM}
              size="mini"
            />
          </div>
        </Drawer>
        <Drawer
          placement="right"
          closable={false}
          mask={false}
          open={showList}
          getContainer={false}
        >
          <WorkList
            defaultList={imgList}
            onClose={() => setShowList(false)}
            onSelect={onSelect}
          />
        </Drawer>
        <div className="flex-1 px-10px overflow-y-auto nw-scrollbar-thin overflow-x-hidden">
          <AigcFormItem
            title="作品描述"
            isRequired
            className="bg-[#fff] mb-0px text-14px px-0px"
          >
            <div
              className={`relative aigc-textarea transition-colors duration-300 flex flex-col gap-4px rounded-8px pt-12px bg-white border-1px ${isFlashing ? 'border-[#1890ff] ring-2 ring-[#1890ff20]' : ''}`}
              style={{ aspectRatio: '36/13' }}
            >
              <Input.TextArea
                value={modelValue}
                onChange={e => {
                  updateModelValue(e.target.value);
                }}
                maxLength={200}
                placeholder="聊聊你的作品灵感吧"
                className="all-unset nw-scrollbar nw-scrollbar-thin flex-1 showCount leading-22px !p-12px !py-0 !rounded-none !shadow-none !border-none !outline-none !resize-none"
              />
              <div className="relative p-8px rounded-8px pt-4px bg-white text-12px flex items-center justify-center ">
                <p className="text-black mb-0 ml-auto ">
                  {modelValue?.length}{' '}
                  <span className="text-black text-opacity-30">/ 200</span>
                </p>
              </div>
            </div>
          </AigcFormItem>
          <AigcFormItem
            title="描述词"
            className="bg-[#fff] mb-0px pt-0px text-14px px-0px"
          >
            <div className="cursor-not-allowed relative min-h-[130px] border-1px border-[#1d21291a] bg-[#F7F8FC] rounded-8px py-12px px-14px text-[#1d212980]">
              {dataJSON?.prompt}
            </div>
          </AigcFormItem>
          {type === 'image' && (
            <AigcFormItem
              title="背景音乐"
              className="text-14px relative"
              titleActionComp={
                <div className="absolute left-80px top-19px">
                  <Tooltip
                    zIndex={9999}
                    trigger="hover"
                    title="仅在纳米APP端生效"
                  >
                    <span>
                      <SVGPureIcon name="publish-prompt" size={16} />
                    </span>
                  </Tooltip>
                </div>
              }
            >
              <SingleSelect
                onClick={onShowDopdown}
                item={bgmItem}
                modelValue={bgmId}
              />
            </AigcFormItem>
          )}
          <div className="flex items-center justify-between mb-12px">
            <span className="text-14px text-[#000]">允许做同款</span>
            <Switch checked={sameWork} onChange={val => setSameWork(val)} />
          </div>
        </div>
        <div className="flex flex-col">
          <button
            className={`aigc-submit-btn flex items-center justify-center flex-shrink-0 leading-12px h-44px bg-[#000] rounded-12px text-[#fff] text-16px`}
            style={{
              background: isLoading
                ? 'rgba(0,0,0,.1)'
                : 'linear-gradient(to right, #484E5F 0%, #242425 50%, #484E5F 100%)',
            }}
            onClick={submit}
          >
            确认发布
          </button>
        </div>
      </div>
    </div>
  );
});
export default Publish;
